import type { TextFieldProps } from '@mui/material';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const SearchField = (props: SearchFieldProps) => {
  return (
    <TextField
      variant="standard"
      helperText=""
      placeholder="Search"
      {...props}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon color="primary" />
          </InputAdornment>
        ),
      }}
    />
  );
};

type InputProps = Omit<TextFieldProps['InputProps'], 'endAdornment'>;

type SearchFieldProps = Omit<TextFieldProps, 'InputProps'> & {
  InputProps?: InputProps;
};
